/**
 * Ryan O'Dowd
 * 2024-11-24
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import Button from '@components/common/Button';
import EmptyScreen from '@components/common/EmptyScreen';
import React from 'react';
import WidgetBase from '@components/WidgetBase';
import {
  YEAR_IN_REVIEW_ROUTE,
} from '@utils/store/actions';
import getStyles from './styles';
import hooks from '@hooks';

const YearInReview = (props: YearInReviewProps) => {
  const navigation = hooks.useNavigation();
  const styles = hooks.useStyles(getStyles);
  const i18n = hooks.useI18n();

  return (
    <WidgetBase.Container
      layout={props.layout}
      cellSize={props.cellSize}
    >
      <WidgetBase.Header
        title={i18n('yearInReview')}
        onPress={() => navigation.navigate(YEAR_IN_REVIEW_ROUTE, {
          year: props.year,
        })}
      />
      <WidgetBase.Content>
        <EmptyScreen.Wrapper>
          <EmptyScreen.Text>
            {i18n('yearInReviewEmptyScreenText')}
          </EmptyScreen.Text>
          <Button
            mode='contained'
            theme={styles.colors.accent}
            onPress={() => navigation.navigate(YEAR_IN_REVIEW_ROUTE, {
              year: props.year,
            })}
          >
            See my stats
          </Button>
        </EmptyScreen.Wrapper>
      </WidgetBase.Content>
    </WidgetBase.Container>
  );
};

class YearInReviewProps {
  layout: {
    x: number,
    y: number,
    w: number,
    h: number,
  }; // @TODO: type
  cellSize: number;
  year: number;
};

export default YearInReview;
